import { useTranslations } from "next-intl";

import { Icon } from "@zapier/zinnia-icons";
import { Tag, Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";

import { useSize } from "@zapier/reporting/src/hooks/useSize";
import { getTooltipPosition, pillOverride } from "../indicatorStyles";

/**
 * Bulk import indicator icon with tooltip, displayed when a run originated
 * from a Zapier Table bulk import.
 */
function BulkImportIndicator() {
  const t = useTranslations("run-log.bulk-import-indicator");
  const size = useSize();

  return (
    <Tooltip content={t("label")} placement={getTooltipPosition(size)}>
      <TooltipFocusableTrigger>
        <div
          aria-label={t("label")}
          css={pillOverride}
          data-testid="bulk-import-indicator"
          role="img"
        >
          <Tag variant="UiPrimaryWeaker" size="x-small">
            <Icon color="UiPrimaryStrongest" name="arrowConnect" size={16} />
          </Tag>
        </div>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}

export default BulkImportIndicator;
